const KEY = 'appUsers.onlyUnread.v1';

export function readOnlyUnread(): boolean {
  try {
    return localStorage.getItem(KEY) === 'true';
  } catch {
    return false;
  }
}

export function saveOnlyUnread(value: boolean): void {
  try {
    localStorage.setItem(KEY, String(value));
  } catch {
    // Browsing without storage still keeps the setting for this visit.
  }
}
